import memoizeOne from "memoize-one";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import { PropTypeShapes } from "../../types";
import { ZoomContext } from "./ZoomContext";

const getZoomContextValue = memoizeOne((stateZoom, onZoomChange, zoomMinimum, zoomMaximum) => {
  return {
    zoom: stateZoom,
    onZoomChange,
    zoomMinimum,
    zoomMaximum
  };
});

class ZoomContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      zoom: props.initialZoom ? props.initialZoom : 1.0
    };
    this.onZoomChange = this.onZoomChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.initialZoom && nextProps.initialZoom !== this.props.initialZoom) {
      this.setState({
        zoom: nextProps.initialZoom
      });
    }
  }

  onZoomChange(inZoom) {
    let zoom = inZoom;
    if (this.props.zoomMinimum && zoom < this.props.zoomMinimum) {
      zoom = this.props.zoomMinimum;
    }
    if (this.props.zoomMaximum && zoom > this.props.zoomMaximum) {
      zoom = this.props.zoomMaximum;
    }
    // Call the provided callback if it has been set
    if (this.props.onZoom) {
      this.props.onZoom(zoom);
    }
    // And then update our state so we re-render
    this.setState({
      zoom
    });
  }

  render() {
    const zoomContext = getZoomContextValue(
      this.state.zoom,
      this.onZoomChange,
      this.props.zoomMinimum,
      this.props.zoomMaximum
    );
    return (
      <React.Fragment>
        <ZoomContext.Provider value={zoomContext}>{this.props.children}</ZoomContext.Provider>
      </React.Fragment>
    );
  }
}

ZoomContainer.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  initialZoom: PropTypes.number,
  zoomMinimum: PropTypes.number,
  zoomMaximum: PropTypes.number,

  // Something that responds to zoom
  onZoom: PropTypes.func
};

export default ZoomContainer;
